import React from "react";

const LiveMarker = () => {
  return <div className="pulseIcon" />;
};

export default LiveMarker;
